import { Box, Stack, Typography } from '@mui/material';

import { Button } from '@/components/form/baseInputs/Button';
import { TextInput } from '@/components/form/baseInputs/TextInput';
import { Copy07Icon } from '@/components/icons/Copy07Icon';
import { Stars01Icon } from '@/components/icons/Stars01Icon';
import { COLORS } from '@/styles/tokens/colors';

interface EditorHeaderProps {
  isSystemPrompt: boolean;
  displayName: string;
  onDisplayNameChange: (name: string) => void;
  onDuplicate: () => void;
  onOpenImproveModal: () => void;
  duplicating: boolean;
  improving: boolean;
  isPromptEmpty: boolean;
}

export function EditorHeader({
  isSystemPrompt,
  displayName,
  onDisplayNameChange,
  onDuplicate,
  onOpenImproveModal,
  duplicating,
  improving,
  isPromptEmpty,
}: EditorHeaderProps) {
  return (
    <Stack
      direction="row"
      spacing={2}
      alignItems="center"
      justifyContent="space-between"
      sx={{
        px: 2,
        py: 1.5,
        borderBottom: '1px solid',
        borderColor: COLORS.GRAY[200],
      }}
    >
      {isSystemPrompt ? (
        <Typography variant="title-s" sx={{ flex: 1 }}>
          {displayName}
        </Typography>
      ) : (
        <Box width={225}>
          <TextInput
            fullWidth
            label=""
            value={displayName}
            onChange={(e) => onDisplayNameChange(e.target.value)}
            placeholder="Prompt name"
          />
        </Box>
      )}
      <Stack direction="row" spacing={1}>
        <Button
          size="sm"
          // this is the primary action for a system prompt
          variant={isSystemPrompt ? 'primary' : 'secondary'}
          startIcon={Copy07Icon}
          onClick={onDuplicate}
          loading={duplicating}
        >
          Duplicate
          {isSystemPrompt ? ' to customize' : ''}
        </Button>
        {!isSystemPrompt && (
          <Button
            size="sm"
            variant="secondary"
            startIcon={Stars01Icon}
            onClick={onOpenImproveModal}
            disabled={improving}
          >
            {isPromptEmpty ? 'Create prompt' : 'Improve prompt'}
          </Button>
        )}
      </Stack>
    </Stack>
  );
}
